export default {
  SITE:{
    NAME         :'Pareto',
    CANONICAL    :'https://pareto.ai',
    SUPPORT_EMAIL:'team@pareto.ai',
  },
  SOCIAL:{
    FACEBOOK :'https://www.facebook.com/hellopareto',
    INSTAGRAM:'https://www.instagram.com/hellopareto',
    TWITTER  :'https://www.twitter.com/hellopareto',
    LINKEDIN :'https://www.linkedin.com/company/hellopareto',
    THREADS  :'https://www.threads.net/@hellopareto',
  },
  EXTRA:{
    JOBS           :'https://coda.io/@hellopareto/join-our-team',
    TRAINER_SURVEY :'https://paretoai.typeform.com/ai-trainer',
    CODE_OF_CONDUCT:'https://coda.io/d/_dr5LIWr56Zl/Code-of-Conduct_sui96Vp5',
  },
}
